var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27344 0.188477C9.33513 0.18848 10.3863 0.39745 11.3672 0.803711C12.3482 1.21004 13.2394 1.80584 13.9902 2.55664C14.741 3.30743 15.3368 4.19874 15.7432 5.17969C16.1494 6.16057 16.3584 7.21176 16.3584 8.27344C16.3584 9.33513 16.1494 10.3863 15.7432 11.3672C15.3368 12.3482 14.741 13.2394 13.9902 13.9902C13.2394 14.741 12.3482 15.3368 11.3672 15.7432C10.3863 16.1494 9.33513 16.3584 8.27344 16.3584C6.12907 16.3584 4.07294 15.5065 2.55664 13.9902C1.04034 12.4739 0.188483 10.4178 0.188477 8.27344C0.188477 6.12906 1.04034 4.07294 2.55664 2.55664C4.07294 1.04034 6.12906 0.188477 8.27344 0.188477ZM11.0996 4.80664L7.2793 9.39062L5.24609 7.35742L3.68066 8.92285L3.81348 9.05664L6.57129 11.8145L7.2832 12.5254L7.42871 12.6709L7.56055 12.5127L8.2041 11.7402H8.20508L12.8008 6.22461L12.9209 6.08008L12.7773 5.95996L11.3652 4.7832L11.2207 4.66211L11.0996 4.80664Z",
    fill: "#266FD1",
    stroke: "#0046C3",
    strokeWidth: 0.376064
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTickIcon);
export default __webpack_public_path__ + "static/media/blueTickIcon.56cbf432d2d425ed553ce289c8d0bb71.svg";
export { ForwardRef as ReactComponent };